import { TraceEvent } from '~/protos/agents'
import { getDeviceId } from '~/utils/storage'
import { UserSocket } from './socket'

export interface DataPoint {
  event: keyof typeof TraceEvent
  url?: string
  source?: string
  client_id?: string
  labels?: Record<string, string>
}

const TRACE_URL = 'https://trace.curietech.workers.dev/api/analytics/trace'

let consecutiveFailures = 0
const MAX_FAILURES = 3
const BACKOFF_MS = 60_000
let backoffUntil = 0

const NOOP_RESPONSE = new Response(null, { status: 204 })

export function trace(event: keyof typeof TraceEvent): Promise<Response>
export function trace(event: Omit<DataPoint, 'client_id'>): Promise<Response>
export function trace(point: Omit<DataPoint, 'client_id'> | string) {
  if (consecutiveFailures >= MAX_FAILURES && Date.now() < backoffUntil) {
    return Promise.resolve(NOOP_RESPONSE)
  }

  const dataPoint = (typeof point === 'string' ? { event: point } : point) as DataPoint
  const labels = dataPoint.labels || {}
  const dataPointToBeUsed = Object.assign(dataPoint, {
    url: window.location.href,
    source: dataPoint.source || localStorage.getItem('source'),
    client_id: getDeviceId(),
    client_version: __GIT_REV__.trim(),
    labels: Object.assign(labels, {
      is_ws_connected: UserSocket.isConnected()
    })
  })
  return fetch(TRACE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(dataPointToBeUsed)
  })
    .then(res => {
      if (res.ok) {
        consecutiveFailures = 0
      } else {
        consecutiveFailures++
        if (consecutiveFailures >= MAX_FAILURES) {
          backoffUntil = Date.now() + BACKOFF_MS
        }
      }
      return res
    })
    .catch(err => {
      consecutiveFailures++
      if (consecutiveFailures >= MAX_FAILURES) {
        backoffUntil = Date.now() + BACKOFF_MS
      }
      throw err
    })
}
